import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

const TagCircleIcon = (props) => (
  <SvgIcon viewBox="0 0 76 76" {...props}>
    <rect width="76" height="76" rx="38" fill={props.sx?.color || '#D22C0F'} />
    <path
      d="M37.1723 21.172L19.1723 39.172C17.6103 40.734 17.6103 43.266 19.1723 44.828L31.1723 56.828C32.7343 58.39 35.2663 58.39 36.8283 56.828L54.8283 38.828C55.5783 38.078 56.0003 37.06 56.0003 36V24C56.0003 21.79 54.2103 20 52.0003 20H40.0003C38.9403 20 37.9223 20.422 37.1723 21.172ZM49.0003 30C47.3443 30 46.0003 28.656 46.0003 27C46.0003 25.344 47.3443 24 49.0003 24C50.6563 24 52.0003 25.344 52.0003 27C52.0003 28.656 50.6563 30 49.0003 30Z"
      fill="white"
    />
  </SvgIcon>
);

TagCircleIcon.propTypes = {
  sx: PropTypes.object,
};

export default TagCircleIcon;
